module.exports = __webpack_public_path__ + "media/illustrations/resultados-busca-314a5de3.svg";